//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {BProgress, BProgressBar} from "bootstrap-vue";
import {modelStates} from "@/constants";
import "@nuxeo/nuxeo-elements/nuxeo-operation.js";
import {mapGetters, mapMutations} from "vuex";
import {insightService} from "@/insight-service";

export default {
  name: "TrainingModelCard",

  components: {BProgress, BProgressBar},

  props: {
    model: {
      type: Object,
      value: {}
    }
  },

  data() {
    return {
      progressSteps: 0,
      progress: 0,
      progressPending: 0,
      elapsedTime: ""
    };
  },

  computed: {
    ...mapGetters(["modelsPP", "currentClient"]),
    progressLabel() {
      return `${this.progress}%`;
    },
    inputs() {
      const inputs = this.model.properties["ai_model:inputs"];
      return inputs.map(e => e.name);
    },

    outputs() {
      const outputs = this.model.properties["ai_model:outputs"];
      return outputs.map(e => e.name);
    },

    isModelFailed() {
      return (
          this.model.state === modelStates.FIRST_TRAINING_ERROR ||
          this.model.state === modelStates.EVALUATION_ERROR ||
          this.model.state === modelStates.NOT_TRAINED
      );
    },

    isFavorites() {
      if (this.model) {
        return this.model.contextParameters.favorites.isFavorite;
      }
      return false;
    }
  },

  mounted() {
    this.loadModelMetrics();
  },

  methods: {
    selectClick(e) {
      this.$toasted.show(`Select btn clicked ${e}`, {duration: 2000});
    },

    navigateToModel() {
      this.setCurrentModel(this.model);
      this.$router.push({name: "model", params: {id: this.model.uid}});
    },

    toggleFav() {
      insightService.toggleFavorite(
          this.model,
          this.$refs.addFav,
          this.$refs.removeFav,
          this.displaySuccess,
          this.displayError,
          this.setModels,
          this.modelsPP
      );
    },
    loadModelMetrics() {
      window.setTimeout(() => {
        const results = insightService.fillTrainingMetrics(this.model);
        this.progress = results.progress;
        this.progressPending = (results.progressPending * 100).toFixed(2);
        this.progressSteps = (results.progressSteps * 100).toFixed(2);
        this.elapsedTime = results.elapsedTime;
        if (insightService.isRunning(this.model)) {
          this.startElapsedTrainingTimeCounter();
        }
      }, 100);
    },
    startElapsedTrainingTimeCounter() {
      const jobInfo = this.model.contextParameters.jobInfo;
      if (jobInfo) {
        window.setTimeout(() => {
          const time = insightService.getElapsedTime(jobInfo.startDate);
          this.elapsedTime = `${time}`;
          this.startElapsedTrainingTimeCounter();
        }, 1000);
      }
    },
    ...mapMutations({
      displaySuccess: "displaySuccess",
      displayError: "displayError",
      setModels: "setModels",
      setCurrentModel: "setCurrentModel"
    })
  }
};
